var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChatBubbleLeftIcon } from "@heroicons/react/24/outline";
import { useContext, useEffect, useRef, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { WPQTIconButton } from "../../../components/common/Button/Button";
import { WPQTTextarea } from "../../../components/common/TextArea/TextArea";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { UserPageNotificationsContext } from "../../providers/UserPageNotificationsContextProvider";
import { CommentItem } from "./CommentItem/CommentItem";
function CommentsApp({ comments, addComments }) {
    const { checkNewComments } = useContext(UserPageNotificationsContext);
    const [comment, setComment] = useState("");
    const commentsContainerRef = useRef(null);
    const { storeComments } = useLocalStorage();
    useEffect(() => {
        if (commentsContainerRef.current) {
            commentsContainerRef.current.scrollTo({
                top: commentsContainerRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    }, [comments]);
    useEffect(() => {
        if (comments && comments.length > 0) {
            storeSeenComments();
        }
    }, [comments]);
    const saveComment = () => {
        addComments(comment);
        setComment("");
    };
    const storeSeenComments = () => __awaiter(this, void 0, void 0, function* () {
        yield storeComments(comments);
        yield checkNewComments();
    });
    return (_jsxs("div", { className: "wpqt-flex wpqt-flex-col wpqt-gap-7", children: [_jsx("div", { ref: commentsContainerRef, className: "wpqt-comments-app-height wpqt-overflow-y-auto", children: comments && comments.length === 0 ? (_jsx("div", { className: "wpqt-text-center", children: __("No comments found", "quicktasker") })) : (_jsx("div", { className: "wpqt-grid wpqt-grid-cols-1 md:wpqt-grid-cols-[auto_1fr] wpqt-gap-3 md:wpqt-gap-8 wpqt-items-center wpqt-px-2", children: comments.map((comment) => {
                        return _jsx(CommentItem, { comment: comment }, comment.id);
                    }) })) }), _jsxs("div", { className: "wpqt-flex wpqt-flex-col wpqt-gap-4 wpqt-w-full md:wpqt-w-2/4 wpqt-mx-auto", children: [_jsx(WPQTTextarea, { value: comment, onChange: setComment }), _jsx(WPQTIconButton, { text: __("Add comment", "quicktasker"), onClick: saveComment, icon: _jsx(ChatBubbleLeftIcon, { className: "wpqt-icon-green wpqt-size-5" }) })] })] }));
}
export { CommentsApp };
